import { createContext } from 'react';
import { StoryListContextType } from '#advertStory/list';

const StoryListContext = createContext<StoryListContextType>(null);

export { StoryListContext };
